import { Box, Chip, Divider, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { getConfirmedOrders } from 'redux/reducers/orders/selectors';
import { representationSchemeType } from 'services/constants/representationSchemeType';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { TOrderDiscountsItemProps } from './types';
import { AmountWithQuantity } from './AmountWithQuantity';
import { COLORS } from 'services/constants/colors';
import { EasChip } from 'ui/EasChip';

export const OrderDiscountsItem: FC<TOrderDiscountsItemProps> = ({
	orderDiscountsItem,
	detalization,
	discountOrderBreakdown,
}) => {
	const orders = useSelector(getConfirmedOrders);
	const paymentCurrency = orders?.data?.[0]?.paymentCurrency;

	return (
		<Box>
			<Box
				sx={{
					border: '1px solid #00000020',
					borderRadius: '12px',
					padding: '10px',
					marginBottom: '10px',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'start',
						alignItems: 'center',
						gap: 1,
						mb: 2,
					}}
				>
					<Typography variant="body2" color="text.secondary">
						{orderDiscountsItem?.timestamp &&
							DateTime.fromISO(orderDiscountsItem?.timestamp).toFormat('yyyy-MM-dd, HH:mm')}
					</Typography>
					<EasChip label={orderDiscountsItem?.orderStatus?.replaceAll('_', ' ')} />
				</Box>

				{discountOrderBreakdown?.map((child, index) => (
					<Box sx={{ ml: 2 }} key={`${child.idProvidedByEm}-${index}`}>
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'space-between',
								gap: 2,
							}}
						>
							<Box
								sx={{
									display: 'flex',
									flexDirection: 'row',
									gap: 1,
								}}
							>
								{' '}
								<Typography
									variant="body2"
									sx={{
										fontWeight: 'bold',
									}}
									color="primary"
								>
									{representationSchemeType?.[
										child.repScheme as keyof typeof representationSchemeType
									] ?? child.repScheme}
								</Typography>
								<Typography variant="body2">
									<span style={{ fontWeight: 'bold' }}>{child.idProvidedByEm} — </span>
									{child.shortDescription}
								</Typography>
								<EasChip
									label={`-${child.discountPercentage.toFixed(1)} %`}
									bgcolor={COLORS.DISCOUNT}
								/>
							</Box>

							{detalization ? (
								<AmountWithQuantity
									amount={child.discountOnCost}
									quantity={child.quantity}
									paymentCurrency={paymentCurrency ?? ''}
								/>
							) : (
								<AmountAndCurrency
									amount={
										(+(child.discountOnCost ?? 0) + +(child.discountOnVat ?? 0)) * child.quantity
									}
									currency={paymentCurrency ?? 'EUR'}
									bold
									size={1}
									color={COLORS.PRIMARY}
								/>
							)}
						</Box>
						{detalization && (
							<>
								<AmountWithQuantity
									name="Item VAT"
									amount={child.discountOnVat}
									quantity={child.quantity}
									paymentCurrency={paymentCurrency ?? ''}
								/>

								<Divider sx={{ mt: 0.4, mb: 0.4, ml: 4 }} />
								<AmountWithQuantity
									name=" "
									amount={+(child.discountOnCost ?? 0) + +(child.discountOnVat ?? 0)}
									quantity={child.quantity}
									paymentCurrency={paymentCurrency ?? ''}
									total
								/>
							</>
						)}
					</Box>
				))}
				{(discountOrderBreakdown?.length ?? 0) > 1 && (
					<>
						<Divider sx={{ mt: 1, mb: 1, ml: 4 }} />
						<Box sx={{ display: 'flex', justifyContent: 'end' }}>
							<AmountAndCurrency
								amount={orderDiscountsItem?.totalDiscountAmount ?? 0}
								currency={paymentCurrency ?? 'EUR'}
								bold
								size={1}
							/>

							{/* <Typography
								variant="body1"
								sx={{
									fontWeight: 'bold',
								}}
							>
								{orderDiscountsItem?.total_discount_amount?.toFixed(2)}{' '}
								<span
									style={{
										fontSize: '.8rem',
										color: '#00000080',
										fontWeight: 'normal',
									}}
								>
									{paymentCurrency}
								</span>
							</Typography> */}
						</Box>
					</>
				)}
			</Box>
		</Box>
	);
};
